// [목적] 단일 POI 혼잡도 예측 조회 훅 — useQuery + zod 파싱 + queryKey 일원화
// [이유] WC-TOURAPI-QR-5-04 — CongestionForecastCard 가 poiId 만 넘기면 30일 예측 데이터를 얻을 수 있도록
//         API 호출·캐싱·에러 분기를 훅 레이어에서 캡슐화. TanStack Query 기반 기존 패턴(useFolio 등)과 통일
// [사이드 이팩트] getPoiCongestion → fetchWithEnvelope 경유 → 401 single-flight refresh 자동 처리.
//                 zod parse 실패 시 ZodError 가 useQuery error 로 bubbling → ErrorState 분기
// [수정 시 고려사항] days 변경 시 queryKeys.poi.congestion(poiId, days) 키가 달라져 별도 캐시 엔트리 생성됨.
//                   staleTime 미지정(기본 0) — 혼잡도 데이터는 배치 기반이므로 향후 staleTime=24h 검토 권장

import { useQuery } from '@tanstack/react-query';
import type { CongestionForecast } from '@gangwoncanvas/types';

import { queryKeys } from '../api/queryKeys.js';
import { getPoiCongestion } from '../services/poi-meta.api.js';

// [목적] GET /pois/:id/congestion 래핑 훅 — enabled 가드 포함
// [이유] poiId 가 undefined 인 경우(라우트 파라미터 미확정) 불필요한 요청 방지
// [사이드 이팩트] 없음
// [수정 시 고려사항] poiId 빈 문자열도 falsy 처리되므로 BE uuid 형식이 아닌 값은 enabled=false 로 자동 차단
export function usePoiCongestion(poiId: string | undefined, days = 30) {
  return useQuery<CongestionForecast>({
    queryKey: poiId ? queryKeys.poi.congestion(poiId, days) : ['poi', 'congestion', 'noop'],
    queryFn: () => getPoiCongestion(poiId!, days),
    enabled: !!poiId,
  });
}
